import React from 'react'
import MediaQuery from 'react-responsive'

import { BreakpointsMaxWidth } from 'meta/layout/breakpoints'

import Desktop from './Desktop'
import Mobile from './Mobile'

interface Props {
  codes: string[]
  setShowLineupModal: (show: boolean) => void
}

const Multiple: React.FC<Props> = (props) => {
  const { codes, setShowLineupModal } = props

  return (
    <>
      <MediaQuery maxWidth={BreakpointsMaxWidth.tablet}>
        <Mobile codes={codes} setShowLineupModal={setShowLineupModal} />
      </MediaQuery>
      <MediaQuery minWidth={BreakpointsMaxWidth.tablet}>
        <Desktop codes={codes} setShowLineupModal={setShowLineupModal} />
      </MediaQuery>
    </>
  )
}

export default Multiple
